const routes = [
  {
    path: '/verifactu/requerimiento',
    meta: { needMe: true },
    component: () => import('@/views/verifactu/Requerimiento.vue')
  },
  {
    path: '/verifactu/requerimiento/resultado',
    meta: { needMe: true },
    component: () => import('@/views/verifactu/Resultado.vue')
  },
  {
    path: '/verifactu/enviadas',
    meta: { needMe: true },
    component: () => import('@/views/verifactu/Enviadas.vue')
  },
  {
    path: '/verifactu/comprobar-huella',
    meta: { needMe: true },
    component: () => import('@/views/verifactu/ComprobarHuella.vue')
  },
  {
    path: '/verifactu/exportar-registros',
    meta: { needMe: true },
    component: () => import('@/views/verifactu/ExportarRegistros.vue')
  }
]

export default routes